'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _settings = require('redux/modules/settings');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _utils = require('utils');

var _DownloadSettingsPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/library/DownloadSettingsPopup');

var _DownloadSettingsPopup2 = _interopRequireDefault(_DownloadSettingsPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Convert lods to array
var fields = ['resolution', 'preset',
// 'workflow',
// 'microsurface',

'meshMimeType', 'mimeType', // only used by 3dplants
// 'maxlod',
// 'numberOfLods',

'lodAlbedos', 'lodNormals', 'ztool', 'brushes', 'highpoly', 'vfx', 'lod0', 'lod1', 'lod2', 'lod3', 'lod4', 'lod5', 'lod6', 'lod7', 'lod8', 'components[].type', 'components[].selected', 'components[].mimeType'];

var DownloadSettingsPopupContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {};
}, { update: _settings.update }), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'downloadSettings',
  fields: fields
}, function (state) {
  return {
    form: state.form.downloadSettings,
    user: state.user,
    auth: state.auth
  };
}), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(DownloadSettingsPopupContainer, _React$Component);

  function DownloadSettingsPopupContainer(props) {
    (0, _classCallCheck3.default)(this, DownloadSettingsPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DownloadSettingsPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(DownloadSettingsPopupContainer)).call(this, props));

    var preset = _this.props.fields.preset.value;
    _this.state = {
      switchingPreset: false
    };
    return _this;
  }

  (0, _createClass3.default)(DownloadSettingsPopupContainer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props = this.props,
          update = _props.update,
          values = _props.values,
          asset = _props.asset;

      var type = asset.version === 2 && asset.categories[0].toLowerCase().startsWith('3d') ? '3dplant' : asset.categories[0];

      update(values, type);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var fields = this.props.fields;


      var oldPreset = fields.preset.value;
      var newPreset = nextProps.fields.preset.value;

      if (newPreset !== oldPreset && newPreset.toLowerCase() !== 'custom') {
        var preset = _settings.presets[newPreset];
        var switchingPreset = false;

        fields.components.forEach(function (cmp) {
          var component = preset.find(function (p) {
            return p.type === cmp.type.value;
          });

          if (!_underscore2.default.isEmpty(component)) {
            cmp.selected.onChange(component.selected);
            switchingPreset = true;
          }
        });

        if (switchingPreset) {
          this.setState({ switchingPreset: switchingPreset });
        }
      }

      // Only compare components
      if (newPreset === oldPreset && !_underscore2.default.isEqual(fields._meta.values, nextProps.fields._meta.values)) {
        if (this.state.switchingPreset) {
          this.setState({ switchingPreset: false });
        } else {
          fields.preset.onChange('custom');
        }
      }
    }
  }, {
    key: 'showAlbedos',
    value: function showAlbedos(asset) {
      try {
        var components = asset && asset.components || [];
        var albedo = components.find(function (cmp) {
          return cmp.name.toLowerCase() === 'albedo';
        });
        var albedoUris = albedo && albedo.uris;
        var resolutions = albedoUris && albedoUris[0];
        var formats = resolutions && resolutions.resolutions && resolutions.resolutions[0] && resolutions.resolutions[0].formats;

        var lod = formats.find(function (f) {
          return f.lodType && f.lodType.toLowerCase() === 'lod';
        });

        if (!_underscore2.default.isEmpty(lod)) {
          return true;
        }
      } catch (err) {
        return false;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          fields = _props2.fields,
          childReference = _props2.childReference,
          asset = _props2.asset,
          user = _props2.user,
          auth = _props2.auth;
      var loggedIn = auth.loggedIn;


      var type = asset.categories[0].toLowerCase();
      var is3d = type.toLowerCase() === '3d';
      var isFree = asset.points === 0;

      var aclExrAccess = asset.acl && asset.acl.exrAccess;
      var subscriptionExrAccess = user.subscription && user.subscription.exrAccess;
      var exrAccess = isFree ? 'full' : aclExrAccess || subscriptionExrAccess || 'displacement';
      var showExr = exrAccess === 'full';

      var maxAssetResolution = (0, _utils.getMaxAssetResolution)(asset);

      var subscriptionResolution = user.subscription && user.subscription.accessResolution;
      var accessResolution = maxAssetResolution;

      if (loggedIn) {
        if (!!subscriptionResolution) {
          accessResolution = Math.min(maxAssetResolution, subscriptionResolution);
        }

        if (asset.acl) {
          accessResolution = Math.min(asset.acl.resolution, maxAssetResolution);
        }
      }

      if (isFree) {
        accessResolution = Math.min(maxAssetResolution, 8192);
      }

      var maxLod = (0, _utils.getMaxLOD)(asset);

      var version = asset.version;

      // Uncomment the changes below in PROD. Hard coding for dev-staging.
      var showAlembic = false;
      // const meshes = asset.meshes || [];
      // meshes.forEach(mesh => {
      //   const abc = mesh.uris.find(uri => uri.mimeType === 'application/x-abc');
      //   if (!_.isEmpty(abc)) {
      //     showAlembic = true;
      //   }
      // });

      var settings = {
        exrAccess: exrAccess,
        showExr: showExr,
        showAlembic: showAlembic,
        accessResolution: accessResolution,
        components: asset.components ? asset.components : _underscore2.default.compact(asset.maps.concat(asset.billboards)),
        maxLod: maxLod,
        version: version
      };

      if (fields.resolution.value > accessResolution && accessResolution !== 0) {
        fields.resolution.value = accessResolution;
      }

      if (type.startsWith('3d') && asset.version === 2) {
        fields.components.forEach(function (cmp) {
          cmp.mimeType.value = fields.mimeType.value;

          if (cmp.type.value === 'displacement') {
            if (cmp.mimeType.value === 'image/jpeg') {
              cmp.mimeType.value = 'jpeg+exr';
            }
          }
        });
      }

      // Override JPEG to JPEG+EXR
      if (!(type.startsWith('3d') && asset.version === 2)) {
        fields.components.forEach(function (cmp) {
          if (cmp.type.value === 'displacement') {
            if (cmp.mimeType.value === 'image/jpeg') {
              cmp.mimeType.onChange('jpeg+exr');
            }
          }
        });
      }

      // Check normal if LODNormals is selected
      if (type === '3d' && asset.version !== 2) {
        console.log('fields', fields);
        if (fields.lodNormals.value === true) {
          fields.components.forEach(function (cmp) {
            if (cmp.type.value === 'normal') {
              if (cmp.selected.value !== true) {
                cmp.selected.onChange(true);
              }
            }
          });
        }
      }

      // If all lods are unchecked, highpoly should be checked
      var lods = _underscore2.default.values(_underscore2.default.pick(fields, 'lod0', 'lod1', 'lod2', 'lod3', 'lod4', 'lod5', 'lod6', 'lod7', 'lod8')).map(function (lod) {
        return lod.checked;
      });

      if (_underscore2.default.compact(lods).length === 0) {
        if (fields.highpoly.value !== true) {
          fields.highpoly.onChange(true);
        }
      }

      var showMultipleAlbedos = this.showAlbedos(asset);

      return _react2.default.createElement(_DownloadSettingsPopup2.default, (0, _extends3.default)({}, fields, { onChildRef: childReference, asset: asset, type: type, is3d: is3d, settings: settings, showMultipleAlbedos: showMultipleAlbedos }));
    }
  }]);
  return DownloadSettingsPopupContainer;
}(_react2.default.Component)) || _class) || _class);
exports.default = DownloadSettingsPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DownloadSettingsPopup/DownloadSettingsPopup.jsx
// module id = 2746
// module chunks = 0